import script from "./property-listing-picture-management.vue?vue&type=script&setup=true&lang=ts"
export * from "./property-listing-picture-management.vue?vue&type=script&setup=true&lang=ts"

import "./property-listing-picture-management.vue?vue&type=style&index=0&id=3b453d63&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b453d63"]])

export default __exports__